import { event } from "vue-analytics";

import store from "@/store/index";

function sendConversionEvnet(orderId, price = null) {
  let conversionPrice = 100.0;
  try {
    if (Boolean(price) && Number.isInteger(price))
      conversionPrice = (price / 100.0).toFixed(2);
  } catch (_) {}

  if (process.env.NODE_ENV !== "production") {
    return;
  }

  fbq(
    "track",
    "Purchase",
    { value: conversionPrice, currency: "BRL" },
    { eventID: orderId }
  );

  pintrk("track", "checkout", {
    product_id: orderId,
    value: conversionPrice,
    order_quantity: 1,
    currency: "BRL"
  });
}

export default {
  received(data) {
    switch (data.data.to_state) {
      case "waiting":
        if (store.getters["payable/isPaymentBoleto"]) {
          store.dispatch("payable/updatePaymentMessage", {
            title: "Pronto, o boleto foi gerado!",
            message: "Hora de limpar a casa :)"
          });

          event("cliente", "click", "Compra:Pagamento:boleto:concluido");
          sendConversionEvnet(
            store.state.payable.payable.id,
            store.state.payable.payable.amount.fee
          );

          store.dispatch("payable/setPaymentApprved");
          break;
        }

        store.dispatch("payable/updatePaymentMessage", {
          title: "Solicitação de pagamento enviada!",
          message: "Estamos aguardando o retorno do meio de pagamento..."
        });
        break;

      case "in_analysis":
        store.dispatch("payable/updatePaymentMessage", {
          title: "Mais um pouquinho,",
          message: "O meio de pagamento está analisando o pagamento."
        });
        break;

      case "cancelled":
        event("cliente", "click", "Compra:Pagamento:cancelado");

        store.dispatch("payable/setErrorOnPayment", data.data.detail);

        break;

      case "authorized":
        store.dispatch("payable/updatePaymentMessage", {
          title: "Pronto, pagamento aprovado!",
          message: "Hora de limpar a casa :)"
        });

        event("cliente", "click", "Compra:Pagamento:cartao_credito:concluido");
        sendConversionEvnet(
          store.state.payable.payable.id,
          store.state.payable.payable.amount.fee
        );

        store.dispatch("payable/setPaymentApprved");
        break;
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_Shared/channels/payments.js